"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const animation_1 = require("./animation");
/**
 * Scroll to a specific element.
 *
 * @param to
 * @param duration
 * @param onComplete
 */
function scrollTo(to, duration, onComplete) {
    const element = document.scrollingElement || document.documentElement;
    const start = element.scrollTop;
    const change = to - start;
    const startDate = +new Date();
    const animateScroll = () => {
        const currentDate = +new Date();
        const currentTime = currentDate - startDate;
        element.scrollTop = (0, animation_1.easeInOutQuad)(currentTime, start, change, duration);
        if (currentTime < duration) {
            requestAnimationFrame(animateScroll);
        }
        else {
            element.scrollTop = to;
            onComplete();
        }
    };
    animateScroll();
}
exports.default = scrollTo;
